export const API_CONFIGURATION = 'API_CONFIGURATION'
export const GET_SPREADSHEET_DATA = 'GET_SPREADSHEET_DATA'
export const WRITE_SPREADSHEET_DATA = 'WRITE_SPREADSHEET_DATA'
export const SEND_MESSAGE_TO_GOOGLECHATBOT = 'SEND_MESSAGE_TO_GOOGLECHATBOT'
export const CREATE_SPREADSHEET = 'CREATE_SPREADSHEET'
export const CREATE_EVENT = 'CREATE_EVENT'
export const MODIFY_EVENT = 'MODIFY_EVENT'
export const DELETE_EVENT = 'DELETE_EVENT'
export const DELETE_SPREADSHEET_DATA = 'DELETE_SPREADSHEET_DATA'